import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Plantilla, PlantillasResponse } from '../../../models/plantillas.model';
import { AdministradorDePlantillasService } from './../administrador-de-plantillas.service';
import { AgregarPlantillaComponent } from '../agregar-plantilla/agregar-plantilla.component';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'app/modules/utils-service';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'plantillas-component',
    templateUrl: 'plantillas.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatTableModule,
        MatIconModule,
        MatMenuModule,
        MatPaginatorModule,

        HasPermissionsDirective
    ]
})

export class PlantillasComponent implements OnInit {
    documentos:any= []
    seccionId: number;
    @Input() plantillas: PlantillasResponse

    @ViewChild(MatPaginator) paginator: MatPaginator;
    pageSizes = 10
    inicio:number = 0
    max:number = 10

    _unsubscribe: Subject<any> = new Subject()

    constructor(
        private administradorDePlantillasService: AdministradorDePlantillasService,
        private utilsService: UtilsService,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        
    ) {}

    ngAfterViewInit() {
        this.paginator.page
            .pipe(takeUntil(this._unsubscribe))
            .subscribe(event => {
                const startIndex = event.pageIndex * event.pageSize;
                const endIndex = startIndex + event.pageSize;
                this.inicio = startIndex;
                this.max = endIndex;
                this.administradorDePlantillasService.getPlantillas(this.seccionId, this.inicio, this.max)
            });
    }

    ngOnInit() { 
        this.route.queryParams.subscribe(params => {
            const seccion = params['seccion'];
            this.seccionId = Number(seccion);
        });
    }

    actualizarPlantilla(doc:Plantilla){
        const dialog = this.dialog.open(AgregarPlantillaComponent, {
                panelClass: ['w-full', 'md:w-6/12','mx-0'],
                maxHeight: 'calc(100vh - 4rem)',
                disableClose: true,
                data:{plantilla:doc, actualizarPlantilla:true}
            })
                
    }

    descargar(doc:Plantilla){
        this.administradorDePlantillasService.descargarPlantilla(doc.plantillaId)
         .then(response => {
            this.utilsService.downloadFile(response, doc.nombreDocumento)
        })        
    }

    borrar(doc:Plantilla){
        this.utilsService.open_confirm_dialog(
            `Está seguro que desea Eliminar la plantilla ${doc.nombreDocumento}`, 
            `Eliminar Plantilla`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
               this.administradorDePlantillasService.eliminarPlantilla(doc.plantillaId)
                .then((response) => {
                    this.utilsService.openSuccessSnakBar('Plantilla eliminada correctamente')
                    this.administradorDePlantillasService.getPlantillas(this.seccionId, this.inicio, this.max)
                })
            }
        })
    }

    ngOnDestroy() {
        this._unsubscribe.next(null);
        this._unsubscribe.complete();
    }

}